import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TransactionStatus } from 'src/app/enums/transaction-status.enum';
import { Transaction } from 'src/app/models/transaction.model';
import { AppState } from 'src/app/store';
import * as fromAccountActions from '../../../store/actions/accounts/accounts.actions';
import { accountTransactionImage } from '../../utils/account-transaction-image.utils';
import { checkIfTransactionIsPositive } from '../../utils/transaction-positive.utils';

@Component({
  selector: 'lns-transaction-item',
  templateUrl: './transaction-item.component.html',
  styleUrls: ['./transaction-item.component.scss']
})
export class TransactionItemComponent {
  @Input() transactionData: Transaction | null = null;
  transactionStatus = TransactionStatus;
  addImageToTransaction = accountTransactionImage;
  checkIfTransactionIsPositive = checkIfTransactionIsPositive;

  constructor(private store: Store<AppState>) {}

  selectAccountTransactionDetails(): void {
    this.store.dispatch(
      fromAccountActions.setAccountTransactionDetails({
        accountTransactionDetails: this.transactionData
      })
    );
  }
}
